import React, { useState, useEffect } from "react";
import { useParams, Link, Outlet, useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "react-query";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import { NavigateBackButton } from "../../widgets";
import moment from "moment";

import ClientPolicyRequirementInfo from "../clients/ClientPolicyRequirementInfo";
import PolicyItemStatus from "../../widgets/PolicyItemStatus";

import { CSVLink, CSVDownload } from "react-csv";

const ClientAccountPolicies = () => {
  const { status = "" } = useParams();
  const { Paginate, searchParamString } = usePagination();
  const { api, abortSignal, auth } = useApi();
  const navigate = useNavigate();

  const getPolicies = async (searchString, policyStatus) => {
    try {
      const url = `/client-accounts/policies${searchString}/${policyStatus}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: policies } = useQuery(
    ["policies", searchParamString, status, auth],
    ({ queryKey }) => getPolicies(queryKey[1], queryKey[2])
  );

  const csvData = [
    [
      "Info",
      "Type",
      "Company",
      "Premium",
      "Currency",
      "Policy Number",
      "Effective Date",
      "Expiring on",
      "Status",
    ],
  ];

  policies?.forEach((policy) => {
    const pdata = [
      policy?.title,
      policy?.PolicyType?.name + " - " + policy?.Product?.name,
      policy?.Company?.name,
      policy?.premium,
      policy?.policyCurrency,
      policy?.policyNumber,
      policy?.effectiveDate,
      policy?.expires,
      policy?.status,
    ];

    csvData.push(pdata);
  });

  return (
    <>
      <section id="content" className="content">
        <div className="content__header content__boxed">
          <div className="content__wrap">
            {/* <!-- Breadcrumb --> */}
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/client-policies">My Policies</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  List
                </li>
              </ol>
            </nav>
            {/* <!-- END : Breadcrumb --> */}
            <h1 className="page-title mb-0 mt-2">Policies</h1>
            <p className="lead">
              List of all policies with insurrance companies
            </p>
            <div className="d-md-flex align-items-baseline my-3">
              <CSVLink
                data={csvData}
                filename={"policies.csv"}
                className="btn btn-success btn-sm"
                target="_blank"
              >
                CSV Export
              </CSVLink>

              <div className="d-flex align-items-center gap-1 text-nowrap ms-auto mb-3">
                <NavigateBackButton />
              </div>
            </div>
          </div>
        </div>
        <div className="content__boxed">
          <div className="content__wrap">
            <div className="table-responsive bg-white">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Info</th>
                    <th>Type</th>
                    <th>Company</th>
                    <th>Expires</th>
                    <th>Policy Number</th>
                    <th className="text-center">Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {policies &&
                    policies.map((policy) => (
                      <tr key={policy.id}>
                        <td>
                          {<ClientPolicyRequirementInfo policy={policy} />}
                        </td>
                        <td>
                          {policy?.PolicyType?.name}
                          <br />
                          {policy?.Product?.name}
                        </td>
                        <td>
                          <span className="fw-bold">
                            {policy?.Company?.name}
                          </span>
                        </td>
                        <td>
                          <>
                            <span>
                              {moment(policy?.expires).format("DD/MM/YYYY") ||
                                ""}
                            </span>
                            <p className="text-muted">
                              {policy?.expires &&
                                moment().to(moment(policy?.expires))}
                            </p>
                          </>
                        </td>
                        <td>{policy.policyNumber}</td>

                        <td className="text-center fs-5">
                          <PolicyItemStatus status={policy?.status} />
                        </td>
                        <td className="text-center">
                          <div className="d-flex flex-wrap justify-content-center">
                            <div className="btn-group">
                              <Link
                                to={`/client-account/policy-item/${policy?.id}`}
                                title="View policy"
                                className="btn btn-icon btn-outline-primary"
                              >
                                <i className="bi bi-pencil-square fs-4 text-success"></i>
                              </Link>
                              {/* )} */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <Paginate />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClientAccountPolicies;
